(function(){
'use strict';
var TOPPER_ID=52471062397144;
function init(){
 var form=document.getElementById('cake-product-form');
 if(!form||!document.querySelector('input[name="cake-topper"]'))return;
 var variant=form.querySelector('select[name="id"]');if(!variant)return;
 var flavourLine=form.querySelector('[name="properties[Flavour upgrade]"]');
 if(!flavourLine){flavourLine=document.createElement('input');flavourLine.type='hidden';flavourLine.name='properties[Flavour upgrade]';form.appendChild(flavourLine);}
 function sync(){var f=document.querySelector('input[name="cake-flavour"]:checked');var mud=!!(f&&/mud/i.test(f.value));flavourLine.disabled=!mud;flavourLine.value=mud?f.value+' +$15 (included in cake price)':'';}
 document.addEventListener('change',function(e){if(e.target.matches('input[name="cake-flavour"],input[name="cake-size"]'))sync();});sync();
 form.addEventListener('submit',async function(e){
  sync();var selected=document.querySelector('input[name="cake-topper"]:checked');if(!selected||selected.value!=='add')return;
  e.preventDefault();e.stopImmediatePropagation();
  if(!form.reportValidity())return;
  var button=form.querySelector('button[type="submit"],button[name="add"]');if(button&&button.disabled)return;
  var fd=new FormData(form),props={};
  for(var pair of fd.entries()){var match=pair[0].match(/^properties\[(.*)\]$/);if(match&&typeof pair[1]==='string'&&pair[1].trim())props[match[1]]=pair[1].trim();}
  var cakeId=Number(variant.value),qty=Math.max(1,Number(fd.get('quantity'))||1);
  if(!Number.isSafeInteger(cakeId)||cakeId<=0||!Number.isSafeInteger(qty)||qty>100){alert('Please check your cake selection.');return;}
  var choice=props['Topper artwork']||'';
  var needsFile=/own image|own artwork|image or artwork/i.test(choice);
  var upload=[...document.querySelectorAll('.sp-topper-details input[type="file"],.sp-upload-note input[type="file"]')].find(function(el){return !el.disabled&&el.files&&el.files.length;});
  if(needsFile&&(!upload||!upload.files[0])){alert('Please upload your topper artwork before adding this cake.');return;}
  if(upload&&!upload.checkValidity()){upload.reportValidity();return;}
  if(upload)fd.set('properties[Artwork upload]',upload.files[0]);
  var topper={'For cake':document.querySelector('.sp-panel h1')?.textContent.trim()||'Custom Sugar cake'};
  ['Topper artwork',"Child's name",'Age','Topper message'].forEach(function(k){if(props[k])topper[k]=props[k];});
  if(button){button.disabled=true;button.textContent='Adding your cake…';}
  var cakeAdded=false;
  try{
   fd.set('id',String(cakeId));fd.set('quantity',String(qty));
   var response=await fetch('/cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Accept':'application/json'},body:fd});
   var result=await response.json().catch(function(){return {};});
   if(!response.ok)throw Error(result.description||'Cake or artwork upload failed');
   cakeAdded=true;
   var artworkUrl=result.properties&&result.properties['Artwork upload'];
   if(needsFile&&(!artworkUrl||typeof artworkUrl!=='string'||!/^https:\/\//.test(artworkUrl)))throw Error('Artwork was not confirmed by Shopify. Please check your cart and contact Custom Sugar.');
   if(artworkUrl)topper['Artwork upload']=artworkUrl;
   response=await fetch('/cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:TOPPER_ID,quantity:qty,properties:topper}]})});
   result=await response.json().catch(function(){return {};});
   if(!response.ok)throw Error(result.description||'Could not add personalised topper');
   window.location.assign('/cart');
  }catch(err){
   if(button){button.disabled=false;button.textContent='Add to Cart';}
   alert((cakeAdded?'The cake may be in your cart, but the topper was not completed. Check your cart before trying again. ':'The cake and topper were not added. ')+err.message);
  }
 },true);
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();